import React, { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { useOrderStore } from 'src/hooks/order';
import { __remove, __set } from "src/store/axios_indicator";
import { profileStore } from 'src/hooks/profile';

const CheckoutTotal = (props) => {
    /**
     * "checkout"
     * "SuccessCheckout"
     */
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t, avUserInfoData: { salesOrg } } = System;
    const { speedBoats: { apacAbbr, japanAbbr }, siteUser: { CORE }, salesOrgHK1E } = Constants
    const { isFrom } = props

    const [prop65Part, setProp65Part] = useState(false);

    const [{ CART_DATA, CART_PRODUCTS, CART_SUB_TOTAL, CART_COUNT, }, { }, { }] = useCartStore()
    const [{ place_order_item_list }, { }, { }] = useOrderStore();
    const [{ credit_line_user }, { get_profile_account_information }, { }] = profileStore()

    const [checkoutInfo] = useReduxState({}, 'setCheckoutInfo')
    const [checkOutStepStatus] = useReduxState('', 'setCheckoutStepStatus')

    const shippingAddressInfo = checkoutInfo?.shippingAddressInfo || {}
    const shippingMethodInfo = checkoutInfo?.shippingMethodInfo || {}
    const paymentMethodInfo = checkoutInfo.paymentMethodInfo || {}

    const isOnlySoftwareParts = System.getCurrentRegionWithType(japanAbbr) && CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);

    const checkoutDataModel = {
        estimatedShipping: 0,
        itemsSubTotal: 0,
        orderTotal: 0,
        rateOfExchange: 0,
        estimatedTax: 0,
    }
    const [checkoutData, setCheckoutData] = useReduxState(checkoutDataModel, 'setCheckoutData')
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({ monitorJs: false, frameworkReady: false });

    //  Get profile data
    useEffect(() => {
        async function fetchHere() {
            await get_profile_account_information();
        }
        if (isFrom === Constants.systemModules.SuccessCheckout && System.getCurrentRegionWithType(japanAbbr)) {
            fetchHere()
        }
    }, [])

    useEffect(() => {
        async function containsProp65Yes() {
            if (CART_PRODUCTS && Object.values(CART_PRODUCTS)?.length > 0) {
                const isProp65 = Object.values(CART_PRODUCTS).find(f => f.Prop65Flag === true)
                if (isProp65) {
                    setProp65Part(true)
                } else {
                    setProp65Part(false);
                }
            }
        }
        containsProp65Yes()
    }, [CART_DATA])

    if (isFrom === Constants.systemModules.CHECKOUT) {
        useEffect(() => {
            const total = Object.values(CART_DATA).reduce((sum, item) => {
                const tax = item.subtotal * 0.10;
                return sum + tax;
            }, 0);

            const estimatedTax = System.getCurrentRegionWithType(apacAbbr) ? 0 :
                System.getCurrentRegionWithType(japanAbbr) && !credit_line_user && !isOnlySoftwareParts ?
                    total + Number(shippingMethodInfo.value) * 0.10 :
                    total

            setCheckoutData({
                estimatedShipping: Number(shippingMethodInfo.value) || 0,
                itemsSubTotal: CART_SUB_TOTAL,
                orderTotal: CART_SUB_TOTAL + (Number(shippingMethodInfo.value) || 0) + (Number(estimatedTax) || 0),
                estimatedTax: estimatedTax
            });

        }, [CART_SUB_TOTAL, CART_DATA, shippingMethodInfo?.value, checkOutStepStatus])

    } else if (isFrom === Constants.systemModules.SuccessCheckout) {
        useEffect(() => {
            setCheckoutData({ ...place_order_item_list?.orderEstimation });
        }, [place_order_item_list])
    }

    useEffect(() => {
        if (!monitorFunctionCall?.frameworkReady) {
            System.monitorFrameWorkReady();
            setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true })
        }
    }, []);
    useEffect(() => {
        if (checkOutStepStatus === Constants.checkOutSteps.ADDRESS_STEP) {
            if (!monitorFunctionCall?.monitorJs) {
                System.monitorJSDx()
                setMonitorFunctionCall({ ...monitorFunctionCall, monitorJs: true })
            }
        }
    }, [checkOutStepStatus]);

    return (
        <>
            <div className="checkout-total">
                {__check(['CART_TOTAL_SUMMARY_CALCULATION']).status ?
                    __check(['CART_TOTAL_SUMMARY_CALCULATION']).render
                    :
                    <>
                        <div className='p-15'>
                            <div className="bs5 row mb-1">
                                <div className="col-12">
                                    <div className="bs5 row m-0">
                                        <div className="col-7 px-0">
                                            <span>
                                                <span
                                                    className="cart-item-count">({System.getCurrentCartCount() || place_order_item_list?.items?.length || 0}) </span>
                                                {t('itemsSubtotal')}:
                                            </span>
                                        </div>
                                        <div className="col-5 text-end font_bold_currency ps-1 pe-0">
                                            <span className="font_bold_currency">
                                                {System.getFormatNumber({
                                                    amount: Number(checkoutData?.itemsSubTotal || 0) || 0,
                                                    maximumFractionDigits: 2,
                                                    isDisplaySymbol: false,
                                                    currency: System.getRegionCurrency(),
                                                    roundOff: true
                                                }) || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bs5 row mb-1">
                                <div className="col-8">
                                    <span className='me-1'>
                                        {System.getCurrentRegionWithType(japanAbbr) ?
                                            t('estimatedShippingJapan') :
                                            t('estimatedShipping')}:
                                    </span>
                                    {/* <img src={infoCircle} alt='Estimated Shipping' /> */}
                                </div>
                                {System.getCurrentRegionWithType(apacAbbr, CORE) && salesOrg !== salesOrgHK1E ?
                                    <div className="col-4 text-end font_bold_currency">
                                        <span>--</span>
                                    </div> : (System.getCurrentRegionWithType(japanAbbr) && credit_line_user) || (System.getCurrentRegionWithType(japanAbbr) && isOnlySoftwareParts) ?
                                        <div className="col-4 text-end text-red font_bold_currency">{t('free')}</div> :
                                        <div className="col-4 text-end"><b>{System.getFormatNumber({
                                            amount: Number(checkoutData?.estimatedShipping) || 0,
                                            maximumFractionDigits: 2,
                                            isDisplaySymbol: false,
                                            currency: System.getRegionCurrency()
                                        }) || 0}</b></div>
                                }
                            </div>
                            {System.getCurrentRegionWithType(japanAbbr) && <div className="bs5 row mb-1">
                                <div className="col-8">
                                    <span className='me-1'>{t('consumptionTax')}</span>
                                </div>
                                <div className="col-4 text-end"><b>{System.getFormatNumber({
                                    amount: Number(checkoutData?.estimatedTax) || 0,
                                    maximumFractionDigits: 2,
                                    isDisplaySymbol: false,
                                    currency: System.getRegionCurrency(),
                                    roundOff: true
                                }) || 0}</b>
                                </div>
                            </div>}
                        </div>
                        <div className="bs5 row total-row m-0 ">
                            <div className="bs5 row m-0 font_bold_currency">
                                <div className="col-6 px-0">
                                    <span><b>{t('orderTotal')}</b></span>
                                </div>
                                <div className="col-6 text-end  est-tax ps-1 pe-0">
                                    <>
                                        <span
                                            className="subtotal-currency font-normal">{System.getRegionCurrency()} </span>
                                        <span
                                            className="font_bold_currency">{System.getFormatNumber({
                                                amount: Number(checkoutData?.orderTotal) || 0,
                                                maximumFractionDigits: 2,
                                                isDisplaySymbol: false,
                                                currency: System.getRegionCurrency(),
                                                roundOff: true
                                            }) || 0}</span>
                                    </>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>

            {System.getCurrentRegionWithType(japanAbbr) && <div className="checkout-total mt-2">
                <div className="col-12 p-2">
                    <span>{t('orderTotalText')}</span>
                </div>
            </div>}
        </>
    );
}

export default CheckoutTotal;